export default "__VITE_ASSET__DC_rV3TN__"